import calling_coderegular from './font-data/raw-fonts/callingcode-regular-webfont.ttf';
import pelagiadregular from './font-data/raw-fonts/pelagiad-webfont.ttf';
import almendra_bold from './font-data/raw-fonts/almendra-bold-webfont.ttf';
import benne_regular from './font-data/raw-fonts/benne-regular-webfont.ttf';
import cherryswash_regular from './font-data/raw-fonts/cherryswash-regular-webfont.ttf';
import fantasquesansmono_regular from './font-data/raw-fonts/fantasquesansmono-regular-webfont.ttf';
import fingerpaint_regular from './font-data/raw-fonts/fingerpaint-regular-webfont.ttf';
import ibmplexserif_text from './font-data/raw-fonts/ibmplexserif-text-webfont.ttf';

export function otfFetch(fontChoice, setFontData) {
    let ttfArray = [
        calling_coderegular,
        pelagiadregular,
        almendra_bold,
        benne_regular,
        cherryswash_regular,
        fantasquesansmono_regular,
        fingerpaint_regular,
        ibmplexserif_text
    ];

    async function fetchOtf() {
        let response = await fetch(ttfArray[fontChoice]);
        if (!response.ok) {
            throw new Error('Font file or path invalid');
        }
        let data = await response.blob();
        return data;
    }
    fetchOtf().then(response => setFontData(response)).catch(error => console.log(error));
}